import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { provideStore } from '@ngxs/store';
import { CoreModule } from './core/core.module';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { ChatConversationState } from './features/chat/chat-conversation/chat-conversation.state';
import { ChatState } from './features/chat/chat.state';
import { SocketIoState } from './features/socket-io/socket-io.state';
import { AuthState } from './features/auth/auth-state';
import { authInterceptor } from './features/auth/auth.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideStore([ChatState, ChatConversationState, SocketIoState, AuthState]),
    importProvidersFrom(CoreModule),
    provideNativeDateAdapter(),
  ],
};
